<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody content" :label="$t('Usuarios bloqueados')">
        <el-form :inline="true" label-position="top">
          <el-form-item label="Búsqueda avanzada">
            <el-input placeholder="Ingrese su texto aquí" style="width: 300px" size="small" v-model="search"></el-input>
          </el-form-item>
          <el-form-item>
            <br />
            <el-button icon="el-icon-search" size="small" type="info" @click="getBloqueos">Buscar</el-button>
          </el-form-item>
        </el-form>
        <center v-if="loading">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-table v-else :data="bloqueos" row-class-name="rowClassTablaPloma" cell-class-name="cellClassTablaPloma"
          header-cell-class-name="header-cell-class-table-gray" style="width: 100%">
          <el-table-column prop="rut" label="Rut / Usuario" width="250">
          </el-table-column>
          <el-table-column prop="nombre" label="Nombre" width="300">
          </el-table-column>
          <el-table-column prop="apellido" label="Apellido" width="300">
          </el-table-column>
          <el-table-column prop="fecha_bloqueo" label="Fecha de bloqueo" width="300">
            <template slot-scope="scope">
              {{scope.row.fecha_bloqueo | moment("LLL")}}
            </template>
          </el-table-column>
          <el-table-column width="230" prop="intentos_erroneos" label="Intentos erroneos">
            <template slot-scope="scope">
              <ul>
                <li v-for="(item, index) in scope.row.intentos_erroneos" :key="index">{{ item }}</li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="bloqueado" label="Estado">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.bloqueado" type="danger">Bloqueado</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="bloqueado" label="Estado" v-if="!$store.getters.user.readonly">
            <template slot-scope="scope">
              <el-button size="medium" type="success" @click="desbloquear(scope.row)">Desbloquear</el-button>
            </template>
          </el-table-column>
        </el-table>
        <br />
        <br />
        <center>
          <el-pagination :current-page="page" @prev-click="backPage" @next-click="nextPage"
            @current-change="currentPage" :page-size="6" layout="prev, pager, next" :total="totalPage"></el-pagination>
        </center>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from 'axios';
import { Circle9 } from "vue-loading-spinner";
import moment from "moment-timezone";

export default {
  data() {
    return {
      bloqueos: [],
      loading: false,
      search: "",
      page: 1,
      totalPage: 0,
      paginar: false,
    }
  },
  created() {
    this.$store.dispatch("setSubTitle", "Administración de bloqueos");
    this.getBloqueos();
  },
  components: {
    Circle9,
  },
  methods: {
    async desbloquear(user) {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      this.$confirm("¿Estas seguro que deseas continuar?", "Advertencia", {
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          let response = await axios.post(
            `/usuarios/desbloquearUser`, {
            _id: user._id
          }, config
          );

          if (response.data.success === true) {
            this.loading = false;
            this.$alert(response.data.message, "Información", {
              type: "success",
              confirmButtonText: "Aceptar",
              callback: (action) => { },
            });
            this.getBloqueos();
          } else {
            this.loading = false;
            this.$alert(response.data.message, "Información", {
              type: "error",
              confirmButtonText: "Aceptar",
              callback: (action) => { },
            });
          }
        });
    },
    async getBloqueos() {
      this.loading = true;
      let response = await axios.get(
        `/usuarios/getBloqueos/${this.$store.getters.role.faena_id}/${this.page}/${this.search === "" ? undefined : this.search
        }`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
      );
      this.bloqueos = response.data.results;
      this.totalPage = response.data.total;
      this.paginar = response.data.paginar;
      this.loading = false;
    },
    async currentPage(page) {
      this.page = page;
      this.getBloqueos();
    },
    async nextPage(page) {
      this.page = page;
      this.getBloqueos();
    },
    async backPage(page) {
      this.page = page;
      this.getBloqueos();
    },
  }
}
</script>